import * as React from 'react'
import { translate } from 'react-translate'
const moment = require('moment')

class MdVaultItemSelect extends React.Component<any, any> {

  constructor(props: any) {
    super(props)
    this.state = {
      filteredItems: this.props.vaultItemList,
      focused: false,
      selectedIndex: -1,
      selectedItem: null,
      filter: ''
    }
  }

  private filterItems (inputString?) {
    var filterString = inputString || ''
    let itemsList = _.filter(this.props.vaultItemList, (item: any) => {
      let serialMatch = (item.serialNumber || '').toLowerCase().indexOf(filterString.toLowerCase()) !== -1
      let hallmarkMatch = (item.hallmark || '').toLowerCase().indexOf(filterString.toLowerCase()) !== -1
      let dateMatch = (this.getDepositDate(item) || '').toLowerCase().indexOf(filterString.toLowerCase()) !== -1
      return (serialMatch || hallmarkMatch || dateMatch)
    })

    this.setState({
      filteredItems: itemsList,
      filter: filterString
    })

  }

  public selectItem(item, e) {
    e.preventDefault()
    if (!item) { return }

    this.setState({
      filter: `${item.serialNumber} - ${item.hallmark} - ${this.getDepositDate(item)}`,
      focused: false,
      selectedItem: item
    }, () => {
      this.props.onItemChange(item)
    })
  }

  public handleInputChange(e) {
    e.preventDefault()
    this.filterItems(e.target.value)
  }

  public resetSelection (takeFocus) {
    this.setState({
      selectedIndex: -1,
      filteredItems: [],
      selectedItem: null,
      filter: '',
      focused: takeFocus
    })
    this.filterItems()
    this.props.onItemChange(null)
  }

  private focus() {
    this.setState({
      focused: true
    })
  }

  private unfocus() {
    this.setState({
      focused: false
    })
  }

  private getDepositDate(item: any) {
    return moment(item.lifoDate).format('YYYY/MM/DD')
  }

  public render() {
    let itemsList = this.state.filteredItems
    let t = this.props.t
    return (
      <div>
          <nav className='client-selector-wrapper' style={{ 'width': '100%', 'min-width': 'auto'}}>
            <div>
              <input
                onChange={this.handleInputChange.bind(this)}
                onFocus={() => this.focus()}
                onBlur={() => this.unfocus()}
                onClick={() => this.resetSelection(true)}
                value={this.state.filter}
                type='text'
                placeholder={t('PLACEHOLDER')}

              />
              <div
                className='closeIcon'
                onClick={() => this.resetSelection(false)}>&nbsp;</div>
            </div>
            {(this.state.focused) ? (
              <div className='clientList'>
                <ul>
                  {itemsList.map((item, id) => {
                    return <li key={id} onMouseDown={(e) => this.selectItem(item, e)}>
                      <span>{item.serialNumber} - {item.hallmark} - {this.getDepositDate(item)}</span>
                    </li>
                  })}
                </ul>
              </div>
            ) : (null)}
          </nav>
      </div>
    )
  }
}

export default translate('MdVaultItemSelect')(MdVaultItemSelect)
export { MdVaultItemSelect as MdVaultItemSelectUnconnected }



// WEBPACK FOOTER //
// ./react/components/widgets/MdVaultItemSelect.tsx